import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  LoginLogRequestDTO,
  LoginLogRespondDTO,
} from "../../../types/adminLog";
import adminLogApi from "../../api/admin/AdminLogApi";
import { getAdminInfoFromLocalStorage } from "../../../shared/utils/auth";
import FileSaver from "file-saver";
import dayjs from "dayjs";
import { LogDTO, LogList } from "../../../types/log";

const initialState = {
  loginLog: {} as LoginLogRespondDTO,
  workgroupLog: {} as LogList,
  docLog: {} as LogList,
};
export const trunkGetLoginLog = createAsyncThunk(
  "wapi/admins/logs/login",
  async (logSearchOptions: LoginLogRequestDTO) => {
    const resp = await adminLogApi.getLoginLog(logSearchOptions);
    return resp;
  }
);
export const trunkGetLoginLogExcel = createAsyncThunk(
  "wapi/admins/logs/login/excel",
  async (logSearchOptions: LoginLogRequestDTO) => {
    const resp = await adminLogApi.getLoginLogExcel(logSearchOptions);
    return resp;
  }
);

export const trunkGetWorkgroupLog = createAsyncThunk(
  "wapi/admins/logs/new/paging",
  async (logSearchOptions: LogDTO) => {
    const resp = await adminLogApi.getWorkgroupLog(logSearchOptions);
    return resp;
  }
);
export const trunkGetWorkgroupLogExcel = createAsyncThunk(
  "wapi/admins/logs/new/paging/excel",
  async (logSearchOptions: LogDTO) => {
    const resp = await adminLogApi.getWorkgroupLogExcel(logSearchOptions);
    return resp;
  }
);

export const trunkGetDocLog = createAsyncThunk(
  "wapi/admins/logs/paging",
  async (logSearchOptions: LogDTO) => {
    const resp = await adminLogApi.getDocLog(logSearchOptions);
    return resp;
  }
);
export const trunkGetDocLogExcel = createAsyncThunk(
  "wapi/admins/logs/paging/excel",
  async (logSearchOptions: LogDTO) => {
    const resp = await adminLogApi.getDocLogExcel(logSearchOptions);
    return resp;
  }
);

const adminLogSlice = createSlice({
  name: "adminLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      trunkGetLoginLog.fulfilled,
      (state, { payload: newLogList }) => {
        state.loginLog = newLogList;
      }
    );
    builder.addCase(
      trunkGetLoginLogExcel.fulfilled,
      (state, { payload: res }) => {
        const loginResult = getAdminInfoFromLocalStorage();
        if (res.data && res.headers && loginResult) {
          const file = res.data;
          const userId = JSON.parse(loginResult).userInfo.userId;
          const fileName =
            dayjs().format("YYYYMMDD") + "_login_" + userId + ".xlsx";

          FileSaver.saveAs(file, fileName);
        }
      }
    );
    builder.addCase(
      trunkGetWorkgroupLog.fulfilled,
      (state, { payload: newLogList }) => {
        state.workgroupLog = newLogList;
      }
    );
    builder.addCase(
      trunkGetWorkgroupLogExcel.fulfilled,
      (state, { payload: res }) => {
        const loginResult = getAdminInfoFromLocalStorage();
        if (res.data && res.headers && loginResult) {
          const file = res.data;
          const userId = JSON.parse(loginResult).userInfo.userId;
          const fileName =
            dayjs().format("YYYYMMDD") + "_workgroup_" + userId + ".xlsx";

          FileSaver.saveAs(file, fileName);
        }
      }
    );
    builder.addCase(
      trunkGetDocLog.fulfilled,
      (state, { payload: newLogList }) => {
        state.docLog = newLogList;
      }
    );
    builder.addCase(
      trunkGetDocLogExcel.fulfilled,
      (state, { payload: res }) => {
        const loginResult = getAdminInfoFromLocalStorage();
        if (res.data && res.headers && loginResult) {
          const file = res.data;
          const userId = JSON.parse(loginResult).userInfo.userId;
          const fileName =
            dayjs().format("YYYYMMDD") + "_doc_" + userId + ".xlsx";

          FileSaver.saveAs(file, fileName);
        }
      }
    );
  },
});

export const adminLogActions = adminLogSlice.actions;
export default adminLogSlice.reducer;
